/**
 * Shared shape and helpers for the per-dilution entries stored in a test's
 * `icp_xml_data` attribute. Used by both the ICP grid column renderer and the
 * ICP detail-page "Measurement Runs" table so the two surfaces agree on how a
 * dilution run is labeled.
 */
export interface IcpXmlEntry {
  sampleIDs?: {
    w2?: string | number;
    specificationName?: string;
    dilution?: string | number;
  };
  methodName?: string;
  methodVersion?: string | number;
  measurementDate?: string;
  calculationDate?: string;
}

/** Short dilution label for one icp_xml_data entry (e.g. "100×", spec name, or "Run N"). */
export function icpDilutionLabel(entry: IcpXmlEntry, index: number): string {
  const w2 = entry?.sampleIDs?.w2;
  if (w2 !== undefined && w2 !== null && String(w2).trim() !== '') return `${w2}×`;
  const spec = entry?.sampleIDs?.specificationName;
  if (spec && String(spec).trim() !== '') return String(spec);
  return `Run ${index + 1}`;
}
